/* REACT PACKAGE IMPORTS */
import { useState } from "react";
import { Form } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { postAnswer } from "../../../Features/Sessions/Actions/SessionsActions";

import { decode } from "html-entities";
import { addLineBreak } from "../../../Utilities/format";

export default function SingleChoice({
  position,
  question,
  answer,
  sessionId,
}) {
  const [localAnswer, setLocalAnswer] = useState(answer);
  const dispatch = useDispatch();

  const handleOnChange = (e) => {
    const value = parseInt(e.target.value);
    if (!question.qid) console.log(question.qid);

    const newCurrentAnswer = {
      qid: question.qid,
      answer: { singlechoice: value },
      qhid: question.qhid,
    };

    dispatch(postAnswer({ esId: sessionId, answer: newCurrentAnswer })).then(
      (response) => {
        setLocalAnswer([newCurrentAnswer]);
      }
    );
  };

  const questionText = decode(question?.question);
  const formattedQuestionText = addLineBreak(questionText);

  return (
    <div>
      <p className="fs-4 mb-4">
        <span className="fw-bold">Question {position + 1}</span>:{" "}
        {formattedQuestionText}
      </p>
      <p className="fs-6 fst-italic m-1 text-muted">Select one:</p>
      {
        <ol className={"list-group d-flex flex-row flex-wrap row px-3"}>
          {question.options &&
            question.options.map((option, i) => {
              let defaultChecked =
                localAnswer.length > 0
                  ? localAnswer[0]?.answercontent?.singlechoice === option.qoid
                  : false;
              const optionText = decode(option.opttext);
              return (
                <li
                  key={i}
                  className={
                    option.optimage
                      ? "list-group-item flex-fill col-3"
                      : "list-group-item"
                  }
                >
                  <Form.Check
                    type={"radio"}
                    label={option.opttext ? optionText : ""}
                    aria-label={option.opttext || "Checkbox"}
                    name={`singleAnswer_${question.qid}`}
                    value={option.qoid}
                    defaultChecked={defaultChecked}
                    onChange={(event) => handleOnChange(event)}
                  />
                </li>
              );
            })}
        </ol>
      }
    </div>
  );
}
